<section class="ui-success-state">
  <div class="ui-success-state-icon" aria-hidden="true">ok</div>
  <div class="ui-success-state-copy">
    <h2 class="ui-success-state-title">{{ title() }}</h2>
    @if (hasDescription()) {
      <p class="ui-success-state-description">{{ description() }}</p>
    }
  </div>
  @if (hasAction()) {
    <ui-button size="sm" variant="secondary" (pressed)="handleActionSelected()">
      {{ actionLabel() }}
    </ui-button>
  }
</section>
